import * as React from 'react';
import { CurrentContainerStatus } from 'types/Watchlist';
import { getContainerStatusFormat } from 'utils/container-transforms/transforms';

interface Props {
  status: CurrentContainerStatus | 'all';
}

export const StatusPill: React.FC<Props> = (props) => {
  const { status } = props;

  const format = getContainerStatusFormat(status);

  return (
    <div className={`rounded-full px-2 h-[21px] ${format.colors.text} ${format.colors.background}`}>
      <h4 className="font-medium" title={format?.tooltip}>
        {format?.label}
      </h4>
    </div>
  );
};
StatusPill.displayName = 'Shipments.StatusPill';
